import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { renderPropertyValue } from '../../utils/formatCell';
import { getIsPreview } from '../../utils/isPreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InfoGridRow = ({
  configuredProperty,
  ticket
}) => {
  var _ticket$propertyName;
  const {
    isPreview
  } = getIsPreview();
  const {
    propertyName,
    displayNameOverride
  } = configuredProperty;
  const propertyValue = (_ticket$propertyName = ticket === null || ticket === void 0 ? void 0 : ticket[propertyName]) !== null && _ticket$propertyName !== void 0 ? _ticket$propertyName : null;
  const formattedPropertyValue = renderPropertyValue(propertyValue, configuredProperty);
  const hasValue = formattedPropertyValue != null;
  return (hasValue || isPreview) && /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "heading-25",
      color: "text-core-subtle",
      marginBlockEnd: "0",
      children: displayNameOverride
    }), /*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "body-100",
      marginBlockEnd: "0",
      children: hasValue ? formattedPropertyValue : '—'
    })]
  });
};